'use client';

import React from 'react';

export interface SectionScreenLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

/**
 * Layout de seção: título/subtítulo no topo (texto escuro), conteúdo abaixo em largura total
 * da área principal — sem card global envolvendo a tela.
 */
export const SectionScreenLayout: React.FC<SectionScreenLayoutProps> = ({ title, subtitle, children }) => {
  return (
    <div className="w-full min-w-0 max-w-none flex flex-col flex-1 min-h-0">
      <header className="mb-5 sm:mb-6 shrink-0 text-left">
        <h1 className="text-xl sm:text-2xl font-bold text-navy-dark tracking-tight leading-tight">
          {title}
        </h1>
        {subtitle ? (
          <p className="text-sm sm:text-base text-navy-dark/85 mt-1.5 max-w-4xl leading-relaxed">{subtitle}</p>
        ) : null}
      </header>
      <div className="min-w-0 w-full flex-1">{children}</div>
    </div>
  );
};
